<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/toteList/">Totes</a></li>
      <li class="breadcrumb-item active" aria-current="page">Create Tote</li>
    </ol>
  </nav>
  <div class="row">
  <div class="col">
    <div class="inner-box">
      <div class="row mt-3">
        <div class="col-md-4">
          <label class="text-black mb-3"><b>Create Tote </b></label>
          <div class="row">
            <div class="col">
              <div class="required">
          <div class="form-group required">
            <label class="control-label" for="toteName">Tote Name</label>
            <input type="text" id="toteName" maxlength="50" [(ngModel)]="toteName" class="form-control" (blur)="typeToteName()" [ngClass]="{'is-invalid':toteNameError}" [ngModelOptions]="{standalone: true}" required>
            <div id="toteNameError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!toteNameError">{{toteNameError}}</div>
          </div>
              </div></div></div>
          <div class="row">
            <div class="col">
              <div class="required">
                <div class="form-group ">
                  <label class="control-label" for="toteType">Tote Type</label>
                  <input type="text" id="toteType"  [(ngModel)]="toteType" class="form-control" (blur)="typeToteType()" [ngClass]="{'is-invalid':toteTypeError}" [ngModelOptions]="{standalone: true}"   required>
            <div id="toteTypeError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!toteTypeError">{{toteTypeError}}</div>
          </div>
        </div>
            </div></div></div>
        <div class="col-md-2"></div>
      </div>
    </div>
  </div>
</div>
</section>

<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/toteList" class="btn btn-cancel">Cancel</button>
      <button type="submit" (click)="submitTote()" class="btn btn-orange ml-2">Save</button>
    </div>
  </div>
</div>
